import React from "react";
import { formatDate } from "../../../Utils/utils";

export default function ReviewModal({
  selectedBrand: brand,
  onReject,
  onApprove,
  closeBtnRef,
  loading,
}) {
  return (
    <div
      className="modal fade"
      id="review_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <section className="modal-dialog" role="document">
        <div className="modal-content review-modal--padding">
          <div className="review-modal__header">
            <h1>Brand Review Modal</h1>
            <div>
              <button
                type="button"
                className="review-modal__close-symbol"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div className="review-modal__head">
            <img
              src={brand ? brand.logo : ""}
              alt="brand logo"
              className="review-modal__logo"
            />
            <h2 className="review-modal__name">{brand ? brand.name : ""}</h2>
          </div>
          <div className="review-modal__details-wrapper">
            <dl>
              <div className="review-modal__details-container">
                <dt className="review-modal__details-title">Firstname:</dt>
                <dd>{brand ? brand.firstname : ""}</dd>
              </div>
              <div className="review-modal__details-container">
                <dt className="review-modal__details-title">Email:</dt>
                <dd>{brand ? brand.email : ""}</dd>
              </div>
              <div className="review-modal__details-container">
                <dt className="review-modal__details-title">Territory:</dt>
                <dd>{brand ? brand.territory : ""}</dd>
              </div>
              <div className="review-modal__details-container">
                <dt className="review-modal__details-title">IP Address:</dt>
                <dd>{brand ? brand.ipAddress : ""}</dd>
              </div>
              <div className="review-modal__details-container">
                <dt className="review-modal__details-title">Submitted on: </dt>
                <dd>{brand ? formatDate(brand.createdAt.seconds) : ""}</dd>
              </div>
            </dl>
          </div>
          <div className="review-modal__footer">
            <button
              type="button"
              className="btn review-modal__btn-close"
              data-dismiss="modal"
              aria-label="Close"
              ref={closeBtnRef}
            >
              Close
            </button>
            <div className="review-modal__btn-container">
              <button
                className="btn review-modal__button review-modal__btn-reject"
                type="button"
                onClick={onReject}
              >
                Reject
              </button>
              <button
                className="btn review-modal__button review-modal__btn-approve"
                type="button"
                onClick={onApprove}
              >
                Approve
              </button>
            </div>
            {loading ? (
              <div className="loading-bar">
                <i className="fa fa-1x fa-sync fa-spin text-muted" />
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/PendingCommunities/components/ReviewModal.jsx